// @flow

import React from 'react';
import { EmptyState } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import history from 'src/routes/history';

type Props = {
  heading: string,
  message: string,
  routePath: string
};

type ComposedProps = Props & WithI18nProps;

const EmptyComponent = (props: ComposedProps) => {
  // const backToApp = () => {
  //   const location = window.location;
  //   const url: string =
  //     (location.protocol ? location.protocol + '//' : '') +
  //     location.hostname +
  //     (location.port ? ':' + location.port : '') +
  //     '/admin/apps';

  //   window.top.location.href = url;
  // };
  const { i18n, heading = '' } = props;
  const displayHeading = heading
    ? heading
    : i18n.translate('AdminHTML.Common.Empty.emptyState_Heading');

  const reloadPage = props => {
    const { routePath, redirectUrl } = props;
    console.log('routePath', routePath);
    console.log('redirectUrl', redirectUrl);

    if (routePath) {
      history.push(routePath);
    } else if (redirectUrl) {
      window.top.location.href = redirectUrl;
    } else {
      // window.top.location.reload();
      history.go(0);
    }
  };

  return (
    <div id="BC-Container__Empty">
      <EmptyState
        fullWidth
        heading={displayHeading}
        action={{
          content: i18n.translate('AdminHTML.Common.Action.reload'),
          onAction: () => reloadPage(props)
        }}
        image={getAssetURL(ADMIN_APP_ASSET_PATHS?.inApp?.empty)}>
        <p>{props.message}</p>
      </EmptyState>
    </div>
  );
};

export const Empty = withI18n()(EmptyComponent);
